import { Link } from 'react-router-dom';

export default function Article23() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <Link to="/blog" className="inline-block">
            <img 
              src="https://public.readdy.ai/ai/img_res/994872d3-d12a-41a9-b9a3-399c87796801.png" 
              alt="Practical Living Projects" 
              className="h-12 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Article Content */}
      <article className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/blog" className="inline-flex items-center text-base text-gray-600 hover:text-gray-900 mb-8 transition-colors cursor-pointer whitespace-nowrap">
          ← Back to articles
        </Link>

        <h1 className="text-5xl font-serif font-bold text-gray-900 mb-8 leading-tight">
          What Goes Into a High-Quality TV Installation
        </h1>

        <div className="mb-12 overflow-hidden rounded-lg">
          <div className="w-full h-96 relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/f3ddb4b8fcd470c3cc8c6cfc177e43d8.jpg"
              alt="High-quality TV installation"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            High-quality TV installations are defined by planning, precision, and attention to long-term use. Rather than focusing solely on speed, professionals prioritise correct placement and secure mounting.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            A quality installation considers viewing height, seating distance, and room lighting. Installers also plan cable routing before mounting begins, ensuring that power and connection points are accessible but discreet.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Materials and hardware selection play a role as well. Using brackets and fixings appropriate for the TV's size and weight helps maintain stability over time, even with regular adjustments or movement in the room.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Examples of professionally listed TV installation services can be found at: <a href="https://www.superpages.com.au/company/5891b49eb76262a9548c54a70d482a5f" className="text-gray-900 underline hover:text-gray-600 transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">https://www.superpages.com.au/company/5891b49eb76262a9548c54a70d482a5f</a>
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            From a household budgeting perspective, guidance from <a href="https://moneysmart.gov.au/" className="text-gray-900 underline hover:text-gray-600 transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">MoneySmart</a> helps homeowners understand how to plan for home improvement costs and evaluate service value.
          </p>

          <div className="my-12 border border-gray-200 rounded-lg overflow-hidden">
            <iframe 
              src="https://docs.google.com/forms/d/e/1FAIpQLSeg3CDroI9xiWopEoNBBo7uyWDhXXDO5YWaPXMpzm7JCedKEQ/viewform?embedded=true" 
              width="100%" 
              height="1746" 
              className="border-0"
              title="TV Installation Form"
            >Loading…</iframe>
          </div>
        </div>
      </article>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-24">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <p className="text-sm text-gray-500 text-center">
            © 2025 Practical Living Projects. <a href="https://readdy.ai/?origin=logo" className="hover:text-gray-700 transition-colors whitespace-nowrap cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
